











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingSettingsUpgradeForTeamHealth_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgId",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "08a628963e3b4b62e94429bf9489f8a2";

export default node;
